/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    REQUEST_USER,
    RECEIVE_USER,
    CLEAR_LOADING,
    CLEAR_STATE,
    SET_USER_ATTRIBUTE,
    REQUEST_ROLES,
    RECEIVE_ROLES,
    REQUEST_SUBMIT_USER,
    RECEIVE_SUBMIT_USER,
    SET_ROLE,
    SET_FLEET, REQUEST_FLEETS_HIERARCHY, RECEIVE_FLEETS_HIERARCHY, RECEIVE_FAULTS, REQUEST_FAULTS, RECEIVE_ERROR
} from "./UserActions";


const initialState = {
    user: {
        userName: '',
        firstName: '',
        lastName: '',
        middleName: '',
        email: '',
        roles: [
            {
                id: null,
                fleets: [],
                activities: [],
            }],
        status: 'ACTIVE',
        emailNotification: 'DISABLED',
        externalUser: false,
    },
    loading: false,
    roles: [],
    fleets: [],
    fleetsHierarchy: [],
    faults: [],
    error: null,
}

export const user = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_USER:
        case REQUEST_SUBMIT_USER:
        case REQUEST_ROLES:
        case REQUEST_FLEETS_HIERARCHY:
        case REQUEST_FAULTS:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_USER:
        case RECEIVE_SUBMIT_USER:
            return {
                ...state,
                loading: false,
                user: action.user,
            }
        case CLEAR_LOADING:
            return {
                ...state,
                loading: false,
            }
        case CLEAR_STATE:
            return initialState
        case SET_USER_ATTRIBUTE:
            var newState = {
                ...state,
            }

            const newUser = {}
            newUser[action.key] = action.value
            newState.user = Object.assign({}, newState.user, newUser)
            return newState
        case SET_ROLE:
            var newState = {
                ...state,
            }

            newState.user.roles = newState.user.roles.concat([])
            if (action.index < 0) {
                newState.user.roles.push(action.role)
            } else {
                newState.user.roles = replaceRole(action.index, newState.user.roles, action.role)
            }
            newState.user = Object.assign({}, newState.user)
            return newState
        case SET_FLEET:
            const role = {...action.role}
            role.fleets = action.fleets
            return {
                ...state,
                user: {
                    ...state.user,
                    roles: [role],
                },
            }
        case RECEIVE_ROLES:
            return {
                ...state,
                loading: false,
                roles: action.roles,
            }
        case RECEIVE_FLEETS_HIERARCHY:
            return {
                ...state,
                loading: false,
                fleetsHierarchy: action.fleets,
            }
        case RECEIVE_FAULTS:
            return {
                ...state,
                loading: false,
                faults: action.faults,
            }
        case RECEIVE_ERROR:
            return {
                ...state,
                error: action.error,
            }
        default:
            return state
    }
}

const replaceRole = (index, roles, role) => {
    roles[index] = Object.assign({}, roles[index], role)
    return roles
}